export default {
    reload: "Обновить",
    add: "Добавить строку",
    edit: "Режим 'строчное редактирование'",
    "unit-marine-map": "Судно на карте",
    delete: "Удалить",
    copy: "Копировать строку",
    download: "Экспорт",
    upload: "Импорт",
    styles: "Цвет ячеек",
    columns: "Отображаемые столбцы",
    "view-fields": "Отображаемые столбцы",
    filters: "Фильтры",
    attach: "Прикрепить документ",
    history: "Журнал изменений",
    trash: "Корзина",
    fullRemove: "Удалить безвозвратно",
    rowsLength: "Кол-во строк в таблице",
    restore: "Восстановить",
    "choose-row": "Выбрать строку",
    "tree-table": "Древовидный режим",
    ShowCapitalAccountForm: "Редактировать в форме",
    AccountRemainsIconView: "Остаток по счету",
    "tree-toggle-all": "Развернуть/Свернуть все",
    "copy-delivery": "Создать копию",
    import: "Импорт",
    task: "Поставить задачу",
    manageAssistants: "Назначить/Снять ассистентов",
    manageManagers: "Назначить/Снять менеджеров",
    manageRoles: "Назначить роли/Снять роли",
    manageEmployees: "Назначить/Снять сотрудников",
    export: "Скачать",
    export2: "Скачать",
    changeLog: "Журнал изменений",
    clone: "Копировать",
    cloneCompanyCrm: "Копировать",
    clonePaymentOrder: "Копировать",
    "unit-map": "Груз на карте",
    showUnitFormByLogistas: "Форма",
    "create-combiner": "Создать перевозку",
    showOwnerUnitMap: "Показать карту",
    chat: "Чат",
    reports: "Отчеты",
    CreateInvoicesByFinOpers: "Создать счет",
    IssueInvoiceByFinOpers: "Выставить счет",
    CreateInvoiceByFinOperOrderDocLinks: "Создать счет",
    CapitalOperationsByObject: "Проводки",
    CreateGtdInvoice: "Создать счет с привязкой к ДТ",
    ShowPreviewDynamicJournal: "Открыть журнал"
};
